module.exports = __webpack_public_path__ + "static/media/view5.9e412f97.jpg";